import format from 'date-fns/format';
export const getFormattedTimes = (min, max) => {

    const date = new Date();

    date.setHours(max);
    const maxFormatted = format(date, 'h A');

    date.setHours(min);
    const minFormatted = format(date, 'h A');

    return [minFormatted, maxFormatted];
};


// WEBPACK FOOTER //
// ./src/lib/date-utils.js